<template>
  <v-dialog v-model="dialog" persistent max-width="400">
    <v-card>
      <v-card-title>
        リンクスタイルを作成
        <v-spacer />
        <v-btn icon @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-form ref="productLinkStyle">
          <v-text-field
            v-model="productLinkStyle.name"
            label="名前"
            required
            :rules="[presenceValidation]"
          >
          </v-text-field>
          <p class="my-3">背景色カラーコード</p>
          <v-color-picker
            v-model="backgroundColor"
            hide-inputs
            class="pb-0"
          ></v-color-picker>
          <v-text-field
            v-model="productLinkStyle.backgroundColorCode"
            required
            class="pt-0"
            :rules="[colorCodeValidation(false)]"
          >
          </v-text-field>
          <p class="my-3">文字カラーコード</p>
          <v-color-picker
            v-model="textColor"
            hide-inputs
            class="pb-0"
          ></v-color-picker>
          <v-text-field
            v-model="productLinkStyle.textColorCode"
            required
            class="pt-0"
            :rules="[colorCodeValidation(false)]"
          >
          </v-text-field>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn color="green darken-1" text @click="createProductLinkStyle">
          作成
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from 'axios'
import FormValidationUtilsMixin from '@/mixins/form_validation_utils'
import { deserialize } from 'deserialize-json-api'

export default {
  props: {
    dialog: {
      type: Boolean,
      required: true
    }
  },
  mixins: [FormValidationUtilsMixin],
  data () {
    return {
      productLinkStyle: {
        name: '',
        backgroundColorCode: '#000000',
        textColorCode: '#000000'
      },
      backgroundColor: '#000000',
      textColor: '#000000'
    }
  },
  watch: {
    backgroundColor: function () {
      if (!this.isColorHex(this.backgroundColor)) return
      this.productLinkStyle.backgroundColorCode = this.backgroundColor
    },
    textColor: function () {
      if (!this.isColorHex(this.textColor)) return
      this.productLinkStyle.textColorCode = this.textColor
    },
    'productLinkStyle.backgroundColorCode': function (newValue) {
      if (!this.isColorHex(newValue)) return
      this.backgroundColor = newValue
    },
    'productLinkStyle.textColorCode': function (newValue) {
      if (!this.isColorHex(newValue)) return
      this.textColor = newValue
    }
  },
  methods: {
    closeDialog () {
      this.$emit('close-dialog')
    },
    createProductLinkStyle () {
      if (!this.$refs.productLinkStyle.validate()) {
        return false
      }
      axios
        .post('/api/product_link_styles', {
          product_link_style: {
            name: this.productLinkStyle.name,
            background_color_code: this.productLinkStyle.backgroundColorCode,
            text_color_code: this.productLinkStyle.textColorCode
          }
        })
        .then(
          ({ data }) => {
            this.$emit(
              'selected-product-link-style',
              deserialize(data.data.attributes)
            )
            this.closeDialog()
            const payload = {
              status: 200,
              message: '新しいスタイルを保存しました'
            }
            this.$store.dispatch('SystemMessageStore/createMessage', payload)
            this.productLinkStyle.name = ''
            this.productLinkStyle.backgroundColorCode = ''
            this.productLinkStyle.textColorCode = ''
          },
          ({ response }) => {
            this.$store.dispatch('LoaderStore/hideLoader')
            const payload = {
              status: response.status,
              message: response.data.message
            }
            this.$store.dispatch('SystemMessageStore/createMessage', payload)
          }
        )
    },
    isColorHex (value) {
      return value.match(/^#([0-9a-fA-F]{6})$/) != null
    }
  }
}
</script>
